import Dialog from './src/Dialog'
import _ContactDialog from './src/ContactDialog'

export const ContactDialog = _ContactDialog
export default Dialog